module.exports = __webpack_public_path__ + "static/media/reel-right-arrow-light.bc299a6d.svg";